module.exports = __webpack_public_path__ + "img/callme.c94f979b.png";